import { render } from "./dialog.vue?vue&type=template&id=332b9225&scoped=true&ts=true"
import script from "./dialog.vue?vue&type=script&lang=ts"
export * from "./dialog.vue?vue&type=script&lang=ts"

import "./dialog.vue?vue&type=style&index=0&id=332b9225&lang=scss&scoped=true"

import exportComponent from "/Users/star/Desktop/clz-frontend/taxi-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-332b9225"]])

export default __exports__